export const universities = [
  { value: 'sechenov', label: 'Сеченовский университет (Москва)' },
  { value: 'pirogov', label: 'РНИМУ им. Н.И. Пирогова (Москва)' },
  { value: 'msu_med', label: 'МГУ — факультет фундаментальной медицины' },
  { value: 'spbgmu_pavlov', label: 'ПСПбГМУ им. И.П. Павлова' },
  { value: 'spbgpmu', label: 'СПбГПМУ (педиатрический)' },
  { value: 'mechnikov', label: 'СЗГМУ им. И.И. Мечникова (СПб)' },
  { value: 'spbu_med', label: 'СПбГУ — медицинский факультет' },
  { value: 'military_med', label: 'ВМедА им. С.М. Кирова (СПб)' },
  { value: 'kazan_gmu', label: 'Казанский ГМУ' },
  {
    value: 'privolzhsky',
    label: 'Приволжский исследовательский мед. ун-т (Нижний Новгород)',
  },
  { value: 'samara_gmu', label: 'Самарский ГМУ' },
  { value: 'saratov_gmu', label: 'Саратовский ГМУ им. В.И. Разумовского' },
  { value: 'bashkir_gmu', label: 'Башкирский ГМУ (Уфа)' },
  { value: 'orenburg_gmu', label: 'Оренбургский ГМУ' },
  { value: 'perm_gmu', label: 'Пермский ГМУ им. Е.А. Вагнера' },
  { value: 'kirov_gmu', label: 'Кировский ГМУ' },
  { value: 'rostov_gmu', label: 'Ростовский ГМУ' },
  { value: 'kuban_gmu', label: 'Кубанский ГМУ (Краснодар)' },
  { value: 'stavropol_gmu', label: 'Ставропольский ГМУ' },
  { value: 'volgograd_gmu', label: 'Волгоградский ГМУ' },
  { value: 'astrakhan_gmu', label: 'Астраханский ГМУ' },
  {
    value: 'crimea_med',
    label: 'Мед. академия им. С.И. Георгиевского (Симферополь)',
  },
  { value: 'dagestan_gmu', label: 'Дагестанский ГМУ (Махачкала)' },
  { value: 'north_ossetia_gma', label: 'Северо-Осетинская ГМА (Владикавказ)' },
  { value: 'kabardino_balkar', label: 'КБГУ — мед. факультет (Нальчик)' },
  { value: 'chechen_med', label: 'Чеченский ГУ — мед. институт (Грозный)' },
  { value: 'ural_gmu', label: 'Уральский ГМУ (Екатеринбург)' },
  { value: 'chelyabinsk_gmu', label: 'Южно-Уральский ГМУ (Челябинск)' },
  { value: 'tyumen_gmu', label: 'Тюменский ГМУ' },
  { value: 'novosibirsk_gmu', label: 'Новосибирский ГМУ' },
  { value: 'omsk_gmu', label: 'Омский ГМУ' },
  { value: 'tomsk_gmu', label: 'Сибирский ГМУ (Томск)' },
  { value: 'krasnoyarsk_gmu', label: 'КрасГМУ им. В.Ф. Войно-Ясенецкого' },
  { value: 'kemerovo_gmu', label: 'Кемеровский ГМУ' },
  { value: 'altai_gmu', label: 'Алтайский ГМУ (Барнаул)' },
  { value: 'irkutsk_gmu', label: 'Иркутский ГМУ' },
  { value: 'chita_gma', label: 'Читинская ГМА' },
  { value: 'vladivostok_gmu', label: 'Тихоокеанский ГМУ (Владивосток)' },
  { value: 'khabarovsk_gmu', label: 'Дальневосточный ГМУ (Хабаровск)' },
  { value: 'arkhangelsk_gmu', label: 'Северный ГМУ (Архангельск)' },
  { value: 'petrozavodsk', label: 'ПетрГУ — мед. институт (Петрозаводск)' },
  {
    value: 'kaliningrad',
    label: 'БФУ им. Канта — мед. институт (Калининград)',
  },
  { value: 'voronezh_gmu', label: 'Воронежский ГМУ им. Н.Н. Бурденко' },
  { value: 'kursk_gmu', label: 'Курский ГМУ' },
  { value: 'smolensk_gmu', label: 'Смоленский ГМУ' },
  { value: 'tver_gmu', label: 'Тверской ГМУ' },
  { value: 'yaroslavl_gmu', label: 'Ярославский ГМУ' },
  { value: 'ryazan_gmu', label: 'Рязанский ГМУ им. И.П. Павлова' },
  { value: 'ivanovo_gma', label: 'Ивановская ГМА' },
  { value: 'belgorod', label: 'Белгородский НИУ — мед. институт' },
  { value: 'other', label: 'Другой российский ВУЗ' },
  { value: 'foreign', label: 'Зарубежный ВУЗ' },
]

export const studentCourses = [
  { value: '1', label: '1 курс' },
  { value: '2', label: '2 курс' },
  { value: '3', label: '3 курс' },
  { value: '4', label: '4 курс' },
  { value: '5', label: '5 курс' },
  { value: '6', label: '6 курс' },
  { value: 'intern', label: 'Интерн' },
  { value: 'graduate', label: 'Выпускник' },
]

// Год окончания вуза (для студентов)
const currentYear = new Date().getFullYear()
export const universityGraduationYears = Array.from({ length: 12 }, (_, i) => ({
  value: String(currentYear + i),
  label: String(currentYear + i),
}))

// Год окончания ординатуры (для врачей)
export const residencyGraduationYears = Array.from({ length: 8 }, (_, i) => ({
  value: String(currentYear + i),
  label: String(currentYear + i),
}))

export const studentFaculties = [
  { value: 'general', label: 'Лечебный факультет' },
  { value: 'pediatric', label: 'Педиатрический факультет' },
  { value: 'dental', label: 'Стоматологический факультет' },
  { value: 'pharmacy', label: 'Фармацевтический факультет' },
  { value: 'preventive', label: 'Медико-профилактический факультет' },
  { value: 'nursing', label: 'Факультет высшего сестринского образования' },
]
